export default __webpack_public_path__ + "images/0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8.png";